<template>
    <ModalBase
        name="crear-etiqueta"
        title="Crear nueva etiqueta"
        @close="emitClose"
    >
        <EtiquetaForm
            :etiqueta="tempTag"
            @terminado="crear"
        />
    </ModalBase>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import EtiquetaForm from '@/modules/admin/etiquetas/components/EtiquetaForm.vue';

    const props = defineProps({
        etiqueta: {
            type: Object,
            default: () => ({})
        }
    });

    const emit = defineEmits(['close', 'crear']);

    const tempTag = ref({ ...props.etiqueta });

    watch(() => props.etiqueta, newVal => {
        tempTag.value = { ...newVal };
    }, { deep: true });

    function emitClose() {
        emit('close', 'crear-etiqueta');
    }

    function crear(formData) {
        Object.assign(tempTag.value, formData);
        emit('crear', tempTag.value);
    }
</script>
